import {
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import {
  compareValues,
  SortDirection,
  toggleSortDirection,
} from '../../../lib/utils/sort';
import { ExamLocationService } from '../../../services';
import { ExamLocation } from '../../../types';

@Component({
  selector: 'app-exam-location-table',
  templateUrl: './exam-location-table.component.html',
  styleUrls: ['./exam-location-table.component.scss'],
})
export class ExamLocationTableComponent implements OnInit {
  @HostBinding('class.entity-table-component')
  hostClass = true;

  sortColumn: keyof ExamLocation = 'name';
  sortDirection: SortDirection = 'asc';

  constructor(public service: ExamLocationService) {}

  ngOnInit(): void {
    this.sortColumn = this.service.listState.filter
      .sort as keyof ExamLocation;
    this.sortDirection =
      this.service.listState.filter.direction;
    this.service.loadList();
  }

  get items(): ExamLocation[] {
    const sorted = [
      ...this.service.listState.response.items,
    ];
    return this.sortArray(sorted);
  }

  sortBy(column: keyof ExamLocation) {
    const next = toggleSortDirection(
      this.sortColumn,
      column,
      this.sortDirection
    );
    this.sortColumn = next.column;
    this.sortDirection = next.direction;

    this.service.listState.filter.sort = this.sortColumn;
    this.service.listState.filter.direction =
      this.sortDirection;

    this.service.loadList();
  }

  private sortArray(array: ExamLocation[]): ExamLocation[] {
    return array.sort((a, b) => {
      const aVal = a[this.sortColumn] ?? '';
      const bVal = b[this.sortColumn] ?? '';
      return compareValues(aVal, bVal, this.sortDirection);
    });
  }
}
